/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

// TC/AC UX
import Header from "components/Header/Header.tsx";
import Footer from "components/Footer/PhoenixFooter";

import App from "./App.tsx";
import Home from "client/views/LandingPage/LandingPage";
import { SignInPage } from "client/views/Account/SignInPage";
import { ClassroomPage } from "client/views/ClassroomPage/Classroom.tsx";
import { CoursesListPage } from "client/views/CoursesPage/CoursesListPage.tsx";
import { StudyMain } from "client/views/MyStudy/StudyMain.tsx";
import { CoursePage } from "client/views/CoursesPage/CoursePage.tsx";
import { SupportUsPage } from "client/views/SupportUs/SupportUsPage";
import { ProfilePage } from "client/views/Account/ProfilePage";
import { WelcomePage } from "client/views/Account/WelcomePage";
import { LegalPage } from "client/views/Legal/LegalPage";
import NotFoundPage from "client/views/NotFoundPage.tsx";

export const headerRoutes = [
  // This is a mechanism to make Header shown differently.
  // e.g., home - true to show semi-transparent..., false to make it always opaque and static
  {
    component: Header,
    path: "/clsrm/:cid/:lid",
    show: true,
    home: true,
    clsrm: true,
  },
  {
    component: Header,
    path: "/signin",
    show: true,
    home: false,
  },
  {
    component: Header,
    path: "/lgl/:tab",
    show: true,
    home: false,
  },
  {
    component: Header,
    path: "/sup",
    show: true,
    home: false,
  },
  {
    component: Header,
    path: "/*",
    home: true,
  },
];

export const footerRoutes = [
  // This is a mechanism to show/hide Footer for different pages
  // e.g., hide footer in Classroom page and SignIn page
  {
    component: Footer,
    path: "/clsrm/:cid/:lid",
    show: false,
  },
  {
    component: Footer,
    path: "/signin",
    show: false,
  },
  {
    component: Footer,
    path: "/mys",
    show: false,
  },
  {
    component: Footer,
    path: "/lgl/:tab",
    show: false,
  },
  {
    component: Footer,
    path: "/sup",
    show: false,
  },
  {
    component: Footer,
    path: "/*",
    show: true,
  },
];

export default [
  {
    ...App, // not tying any path, since it's always there
    routes: [
      {
        ...Home, // we got both 'component' and 'loadData'
        path: "/",
        exact: true,
        // icon: Dashboard (unused, for showing a small prefix icon in menu)
      },
      {
        ...ClassroomPage,
        path: "/clsrm/:cid/:lid",
      },
      {
        ...CoursesListPage,
        path: "/cr_list", // All Courses List
      },
      {
        ...CoursePage,
        path: "/crp/:cid", // Course Page
      },
      {
        ...StudyMain,
        path: "/mys", // My Study
      },
      {
        ...ProfilePage,
        path: "/prf/my",
      },
      {
        ...SignInPage,
        path: "/signin",
      },
      {
        ...SupportUsPage,
        path: "/sup/:page",
      },
      {
        ...WelcomePage,
        path: "/prf/wel",
      },
      {
        ...LegalPage,
        path: "/lgl/:tab",
      },
      {
        ...NotFoundPage,
        path: "/my_notes",
      },
      {
        ...NotFoundPage,
        path: "/my_test",
      },
      {
        ...Home,
        path: "/landing",
      },
      {
        ...SignInPage,
        path: "/signinx/:id",
      },
      // {
      //   ...ShoppingPage,
      //   path: "/shp/:tab",
      // },
      // anything else, show page not found
      {
        ...NotFoundPage,
        path: "",
      },
    ],
  },
];
